<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t("View Payment's Information") }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <table class="section-title-table only-for-print">
            <tr>
              <th class="section-title-content">
                {{ $t('Account Payable Payment') }}
              </th>
            </tr>
          </table>

          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <table class="info-table" style="width: 100%">
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select" v-if="isCommission">
                        {{ $t('Salesman') }}
                      </div>
                      <div class="caption no-select" v-else>
                        {{ $t('Supplier') }}
                      </div>
                      <strong v-if="isCommission">{{ viewInfo.sale_man_name || '-' }}</strong>
                      <strong v-else>{{ viewInfo.vender_name || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Recipient Name') }}
                      </div>
                      <strong>{{ viewInfo.recipient_name || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Date') }}</div>
                      <strong>{{ viewInfo.payment_date }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ `${$t('Payment Type')}` }}
                      </div>
                      <strong>{{ viewInfo.cash_remittance_bank | currency }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ `${$t('Amount')} (${systemCurrency})` }}
                      </div>
                      <strong>{{ viewInfo.amount | currency }}</strong>
                    </td>
                    <td class="td-padding-bottom" v-if="viewInfo.discount > 0">
                      <div class="caption no-select">
                        {{ `${$t('Discount')} (${systemCurrency})` }}
                      </div>
                      <strong>{{ viewInfo.discount | currency }}</strong>
                    </td>

                    <td class="td-padding-bottom" v-if="viewInfo.discount > 0">
                      <div class="caption no-select">
                        {{ `${$t('Net Amount')} (${systemCurrency})` }}
                      </div>
                      <strong>{{ (viewInfo.amount - viewInfo.discount) | currency }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Note') }}</div>
                      <strong v-html="lnToBr(viewInfo.payment_note) || '-'" />
                    </td>
                  </tr>
                </table>

                <v-layout row wrap justify-center mt-3 v-if="viewInfo.remittance_details">
                  <table>
                    <tr>
                      <th class="section-title-content">
                        {{ $t('Remittance Details') }}
                      </th>
                    </tr>
                  </table>

                  <v-flex xs10>
                    <v-divider />
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="invoice-content" mt-4 v-if="viewInfo.remittance_details">
                  <v-flex xs12 sm12>
                    <v-layout row wrap>
                      <table class="printed-table" cellspacing="0">
                        <thead>
                          <tr>
                            <th xs1 class="pa-2 view-table-header">#</th>
                            <th class="view-table-header" xs3 pa-2>
                              {{ $t('Remittance Office') }}
                            </th>
                            <th class="view-table-header" xs3 pa-2>
                              {{ $t('Date') }}
                            </th>
                            <th class="view-table-header" xs2 pa-2>
                              {{ `${$t('Commission')} (${systemCurrency})` }}
                            </th>
                            <th class="view-table-header" xs2 pa-2>
                              {{ `${$t('Amount')} (${systemCurrency})` }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in 1" :key="index">
                            <td class="view-table-row">
                              <p class="view-table-content">{{ index + 1 }}</p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ viewInfo.remittance_details.remittance_office_name }}
                              </p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ viewInfo.remittance_details.transaction_date }}
                              </p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ viewInfo.remittance_details.remittance_commission | currency }}
                              </p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ viewInfo.remittance_details.amount | currency }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr class="only-for-print">
                            <td>
                              <div class="footer-space">&nbsp;</div>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <invoice-footer
                  :showSignatureSection="true"
                  :accountantName="viewInfo.accountant"
                  :payerRecipientName="viewInfo.recipient_name"
                  :payerOrRecipient="$t('Recipient')"
                  class="only-for-print"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Close') }}</v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true },
    isCommission: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency
    }
  },

  computed: {
    ...mapGetters({
      viewInfo: 'accountPayments/getPaymentInfo'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    printMe() {
      // we pass true parameter to the function
      // in this way we know that we print invoice and some other style should apply
      // if we don't pass anything it will be false which means
      // we don't print invoice and other styles won't be applied
      // helpers.doPrinting()
      let onlyForPrint = document.querySelectorAll('.only-for-print')
      let notPrintable = document.querySelectorAll('.not-printable')
      let invoiceContent = document.querySelector('.invoice-content')
      let theDialogContent = document.querySelector('.view-dialog-content')
      let infoTable = document.querySelector('.info-table')
      theDialogContent.classList.remove('grey')
      infoTable.classList.add('add-padding-for-info-table')
      invoiceContent.style.marginTop = '90px'
      notPrintable.forEach(element => {
        element.style.display = 'none'
      })
      onlyForPrint.forEach(element => {
        element.style.display = 'block'
      })

      this.$htmlToPaper('printArea', () => {
        infoTable.classList.remove('add-padding-for-info-table')
        theDialogContent.classList.add('grey')
        invoiceContent.style.marginTop = '0px'
        onlyForPrint.forEach(element => {
          element.style.display = 'none'
        })
        notPrintable.forEach(element => {
          element.style.display = 'flex'
        })
      })
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
